import { YetkiInfo } from "./YetkiInfo";

export class AktifKullaniciBilgisi {
    // TOKEN = '';
    // SON_GUNCELLENME_TARIHI = '';
    // KULLANICI_ADI = '';
    // KULLANICI_ID = 0;
    // TC_KIMLIK_NO = '';
    // E_POSTA = '';
    // CEP_TELEFONU = '';
    // ADI = '';
    // SOYADI = '';
    // AD_SOYAD = '';
    // IP_ADRES = '';
    // BURO_ID = 0;
    // BAYI_ID = 0;
    // LISANS_FATURA_TIPI_IDS = [];
    // KULLANICI_TIPI_ID: number = 0;
    // LOGIN_TIPI_ID: number = 0;
    // YETKILI_MI = false;
    // TALEP_YETKILISI_MI = false;
    // MAKBUZ_IMZA_YUKLU_MU = false;
    // AVATAR: string;
    // YetkiInfo: YetkiInfo[] = [];

    TOKEN = '';
    KLCN_GUNCELLENME_TARIHI = '';
    KLNC_ADI = '';
    ID = 0;
    KLNC_TCKN = '';
    KLNC_EMAIL = '';
    KLNC_CEP_TEL = '';
    KLNC_IKINCI_CEP_TEL = '';
    KLNC_AD = '';
    KLNC_SOYAD = '';
    KLNC_AD_SOYAD = '';
    KLNC_IP_ADRES = '';
    KLNC_CLIENT_ID = 0;
    KLNC_BR_ID = 0;
    LISANS_FATURA_TIPI_IDS = [];
    KLNC_TYP_ID = 0;
    KLNC_LGN_TYP_ID = 0;
    KLNC_YETKILI_MI = false;
    TALEP_YETKILISI_MI = false;
    MAKBUZ_IMZA_YUKLU_MU = false;
    AVATAR = '';
    KLNC_BURO_UNVAN = '';
    WEB_SERVIS = '';
    KLNC_YETKI_INFO: YetkiInfo[] = [];

}